function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var updateIconText = function updateIconText(svg, value) {
  var selector = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".value";
  var node = svg.querySelector(selector);
  if (!node) return;
  node.textContent = value;
};

var getAllSlotted = function getAllSlotted(el, name) {
  var slotSelector = "slot[name=\"".concat(name, "\"]");
  var slot = el.shadowRoot.querySelector(slotSelector);
  if (!slot) return [];
  return slot.children;
};

var getSlotted = function getSlotted(el, name) {
  return getAllSlotted(el, name)[0];
};

var containsComposedNode = function containsComposedNode(rootNode, childNode) {
  if (!rootNode || !childNode) return false;
  if (rootNode.contains(childNode)) return true;
  return containsComposedNode(rootNode, childNode.getRootNode().host);
};

var closestComposedNode = function closestComposedNode(childNode, selector) {
  if (!childNode) return null;
  var closest = childNode.closest(selector);
  if (closest) return closest;
  return closestComposedNode(childNode.getRootNode().host, selector);
};

function getActiveElement() {
  var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  var _a;

  var activeEl = root == null ? void 0 : root.activeElement;
  if (!activeEl) return null;
  return (_a = getActiveElement(activeEl.shadowRoot)) != null ? _a : activeEl;
}

function getDocumentOrShadowRoot(node) {
  var _a;

  var rootNode = (_a = node == null ? void 0 : node.getRootNode) == null ? void 0 : _a.call(node);

  if (rootNode instanceof ShadowRoot || rootNode instanceof Document) {
    return rootNode;
  }

  return null;
}

function isElementVisible(element) {
  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;

  if (element.checkVisibility) {
    return element.checkVisibility({
      checkOpacity: true,
      checkVisibilityCSS: true
    });
  }

  var el = element;

  while (el && depth > 0) {
    var style = getComputedStyle(el);

    if (style.opacity === "0" || style.visibility === "hidden" || style.display === "none") {
      return false;
    }

    el = el.parentElement;
    depth--;
  }

  return true;
}

function getPointProgressOnLine(x, y, p1, p2) {
  var segment = distance(p1, p2);
  var toStart = distance(p1, {
    x: x,
    y: y
  });
  var toEnd = distance(p2, {
    x: x,
    y: y
  });

  if (toStart > segment || toEnd > segment) {
    return toStart > toEnd ? 1 : 0;
  }

  return toStart / segment;
}

function distance(p1, p2) {
  return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
}

function getOrInsertCSSRule(styleParent, selectorText) {
  var _a;

  var style;

  var _iterator = _createForOfIteratorHelper(styleParent.querySelectorAll("style")),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      style = _step.value;
      var cssRules = void 0;

      try {
        cssRules = (_a = style.sheet) == null ? void 0 : _a.cssRules;
      } catch (_unused) {
        continue;
      }

      var _iterator2 = _createForOfIteratorHelper(cssRules != null ? cssRules : []),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var rule = _step2.value;
          if (rule.selectorText === selectorText) return rule;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (!(style == null ? void 0 : style.sheet)) {
    return {
      style: {
        setProperty: function setProperty() {},
        removeProperty: function removeProperty() {}
      }
    };
  }

  style.sheet.insertRule("".concat(selectorText, "{}"), style.sheet.cssRules.length);
  return style.sheet.cssRules[style.sheet.cssRules.length - 1];
}

function getNumericAttr(el, attrName) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Number.NaN;
  var attrVal = el.getAttribute(attrName);
  return attrVal != null ? +attrVal : defaultValue;
}

function setNumericAttr(el, attrName, value) {
  var nextNumericValue = +value;

  if (value == null || Number.isNaN(nextNumericValue)) {
    if (el.hasAttribute(attrName)) {
      el.removeAttribute(attrName);
    }

    return;
  }

  if (getNumericAttr(el, attrName, void 0) === nextNumericValue) return;
  el.setAttribute(attrName, "".concat(nextNumericValue));
}

function getBooleanAttr(el, attrName) {
  return el.hasAttribute(attrName);
}

function setBooleanAttr(el, attrName, value) {
  if (value == null) {
    if (el.hasAttribute(attrName)) {
      el.removeAttribute(attrName);
    }

    return;
  }

  if (getBooleanAttr(el, attrName) == value) return;
  el.toggleAttribute(attrName, value);
}

function getStringAttr(el, attrName) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var _a;

  return (_a = el.getAttribute(attrName)) != null ? _a : defaultValue;
}

function setStringAttr(el, attrName, value) {
  if (value == null) {
    if (el.hasAttribute(attrName)) {
      el.removeAttribute(attrName);
    }

    return;
  }

  var nextValue = "".concat(value);
  if (getStringAttr(el, attrName, void 0) === nextValue) return;
  el.setAttribute(attrName, nextValue);
}

export { closestComposedNode, containsComposedNode, distance, getActiveElement, getAllSlotted, getBooleanAttr, getDocumentOrShadowRoot, getNumericAttr, getOrInsertCSSRule, getPointProgressOnLine, getSlotted, getStringAttr, isElementVisible, setBooleanAttr, setNumericAttr, setStringAttr, updateIconText };